import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetOrdenCliente = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/documentos/cliente/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getOrdenClienteMutation: mutation.mutate,
    };
}